import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField, withStyles, Chip } from '@material-ui/core';
import t from "../../../../languages/pl";
import { themeTypeToBool } from '../../../../utils/helpers';


const useStyles = theme => ({
    inputField: {
        margin: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    label: {
        color: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
    }
});

const sampleOptions = [
    {
        keyword: "Paliwo"
    },
    {
        keyword: "Skrzynia"
    },
    {
        keyword: "Spalanie"
    },
    {
        keyword: "Diesel"
    },
    {
        keyword: "Sedan"
    },
];

const SearchKeywords = props => {
    const { classes, options = [], onChange } = props;
    const [focus, setFocus] = useState(false);

    const handleChange = (e, newValue) => onChange && onChange(newValue);

    return (
        <React.Fragment>
            <Autocomplete
                multiple
                id="multiple-limit-tags"
                className={classes.inputField}
                options={options}
                onChange={handleChange}
                getOptionLabel={(option) => option}
                renderTags={(value, getTagProps) => {
                    return value.map((option, index) => {
                        if(index < 2)
                            return <Chip key={index} label={option} {...getTagProps({index})} />;
                        else if(focus){
                            return <Chip key={index} label={option} {...getTagProps({index})} />;
                        }
                        else if(!focus && index === value.length - 1)
                            return `+${value.length - 2}`;
                    });
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label={t.keywords}
                        InputLabelProps={{
                            className: classes.label
                        }}
                        fullWidth
                        onFocus={() => setFocus(true)}
                        onBlur={() => setFocus(false)}
                        />
                )}
            />
        </React.Fragment>
    );
};

SearchKeywords.propTypes = {
    classes: PropTypes.object,
    options: PropTypes.array,
    onChange: PropTypes.func
};

export default withStyles(useStyles)(SearchKeywords);
